import MUIMenuItem, { MenuItemProps as MUIMenuItemProps } from '@mui/material/MenuItem';

export type MenuItemProps<C extends React.ElementType = React.ElementType> = MUIMenuItemProps<C, { component?: C }>;

export const MenuItem = MUIMenuItem;
